import Router from 'vue-router'
import { getAuthState } from './index'
const subPage = {
  template: '<router-view></router-view>'
}

export default class extends Router {
  constructor (arg) {
    super(arg)
    this.map({
      '/login': {
        component: require('./components/pages/Login.vue'),
        noauth: true
        // noloading: true
      },
      '/': {
        name: 'index',
        component: require('./components/pages/Dashboard')
      },
      'dashboard': {
        name: 'dashboard',
        component: require('./components/pages/Dashboard')
      },
      'users': {
        name: 'users',
        component: subPage,
        subRoutes: {
          'overview': {
            component: require('./components/pages/Users/Overview')
          },
          'activities': {
            component: require('./components/pages/Users/Activity')
          }
          // 'geo': {
          //   component: require('./components/pages/Users/GEO')
          // }
        }
      },
      'devices': {
        name: 'devices',
        component: subPage,
        subRoutes: {
          'overview': {
            component: require('./components/pages/Devices/Overview')
          }
          /* 'activities': {
            component: require('./components/pages/Devices/Activity')
          }, */
          // 'geo': {
          //   component: require('./components/pages/Devices/GEO')
          // }
        }
      },
      'issues': {
        name: 'issues',
        component: require('./components/pages/Dashboard')
      },
      'analytics': {
        name: 'analytics',
        component: subPage,
        subRoutes: {
          '/issue_analytics': {
            component: require('./components/pages/Dashboard')
          },
          '/user_activities': {
            component: require('./components/pages/Dashboard')
          },
          '/device_usage': {
            component: require('./components/pages/Dashboard')
          },
          '/event_analytics': {
            component: require('./components/pages/Dashboard')
          }
        }
      },
      'news_letter': {
        name: 'news_letter',
        component: subPage,
        subRoutes: {
          '/write_announcememnt': {
            component: require('./components/pages/Dashboard')
          },
          '/announce_firmware': {
            component: require('./components/pages/Dashboard')
          },
          '/history': {
            component: require('./components/pages/Dashboard')
          }
        }
      }
    })
    this.beforeEach(({ to, next, abort }) => {
      if (to.matched === null) {
        console.log('state is null')
        abort()
        this.replace('/')
      } else if (to.noauth) {
        next()
      } else {
        getAuthState().then(state => {
          console.log(state)
          if (state) {
            return next()
          }
          abort()
          this.replace('/login')
        })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/router.js